import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycabbookinginpune() {



  const cardData =
  {
    keyword: 'Luxury Cab Bookings in Pune',
    heading: 'Aaryan Travels: Luxury Cab Bookings in Pune',
    headingDescription: 'Aaryan Travels offers premium Luxury Cab Bookings in Pune for corporate executives, VIP guests, weddings, and special occasions. Whether you need a high-end sedan, luxury SUV, or chauffeur-driven premium car for airport transfers, business meetings, hotel pickups, or city tours, our fleet ensures unmatched comfort and elegance. With uniformed chauffeurs, spotless vehicles, and on-request amenities like bottled water and Wi-Fi, we provide a first-class travel experience across Pune. From Koregaon Park to Hinjewadi, Kharadi to Baner, Aaryan Travels delivers 24/7 luxury cab services with professional service and punctuality.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of Maratha power, it still echoes the legendary love story of Bajirao and Mastani. Tourists admire its grand Delhi Gate, sprawling gardens, and historic ruins. The evening light-and-sound show narrates tales of valor and legacy. Shaniwar Wada is Pune’s proud symbol of royal heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a vital monument in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were once imprisoned here during the Quit India Movement. The palace now serves as a museum preserving their belongings and stories. Its elegant architecture and lush lawns add to its charm. Aga Khan Palace is Pune’s inspiring tribute to sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located atop a hill 25 km from Pune, is known for the legendary battle of 1670 where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. Trekking up the fort offers thrilling views of the Sahyadri mountains. Local stalls serve hot pithla-bhakri and lemon juice along the route. Monsoon enhances its scenic beauty. Sinhagad is Pune’s favorite blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol is richly adorned with gold and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The spiritual aura offers peace and devotion to all visitors. Dagdusheth is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Its monolithic pillars, chambers, and Nandi mandapa reflect ancient Indian craftsmanship. Despite being in the city center, it offers a calm and meditative atmosphere. Evening chants enhance the spiritual ambiance. Pataleshwar is Pune’s hidden sanctuary of serenity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes traditional musical instruments, sculptures, household antiques, and the recreated Mastani Mahal. Each exhibit tells a story of India’s artistic past. History lovers find it deeply fascinating. The museum is Pune’s treasure vault of culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers breathtaking views of Pune city from its summit. The hilltop temple, dedicated to Lord Shiva and Goddess Parvati, dates back to the Peshwa era. Visitors climb 103 steps to reach the shrine, combining devotion with fitness. The surrounding smaller temples and museum add charm. Parvati Hill is Pune’s peaceful spiritual lookout."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho Ashram in Koregaon Park is an international meditation retreat offering courses in healing, wellness, and mindfulness. The lush gardens, Zen architecture, and peaceful pathways attract visitors from across the globe. The environment promotes relaxation and inner reflection. Osho Ashram is Pune’s global sanctuary of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Inspired by Japan’s Korakuen Garden, Pu La Deshpande Garden is Pune’s largest landscaped park. It features flowing streams, stone bridges, bonsai plants, and manicured lawns. Families enjoy picnics, evening strolls, and photography sessions. Seasonal flowers add vibrant beauty throughout the year. The garden is Pune’s refreshing oasis of greenery."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend spot near Pune. The scenic waterbody and surrounding hills create a picturesque setting, especially during monsoon. Vendors selling corn, tea, and snacks add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape into nature."
  }
],


"services": [
  {
    "name": "Luxury Cab Bookings in Pune",
    "description": "Luxury Cab Bookings in Pune offers an exceptional travel experience with premium vehicles, professional chauffeurs, and top-tier service. Whether for business meetings, special occasions, or airport transfers, we ensure a smooth and stylish journey. Choose from our wide fleet of luxury sedans and SUVs tailored to your comfort and convenience."
  },
  {
    "name": "Book Luxury Taxi Pune",
    "description": "Book Luxury Taxi Pune for a seamless and comfortable ride across the city. Our service features high-end vehicles with top amenities and professional drivers who prioritize punctuality and discretion. Ideal for executives, VIP guests, or special events, we offer an elevated travel experience with easy booking options."
  },
  {
    "name": "Premium Cab Booking Pune",
    "description": "Premium Cab Booking Pune delivers luxury, safety, and reliability with every ride. From airport transfers to business travel and private events, our premium cabs are equipped with modern comforts and operated by courteous chauffeurs. Book online for a stress-free, high-end cab experience in Pune."
  },
  {
    "name": "Chauffeur Driven Luxury Car Pune",
    "description": "Chauffeur Driven Luxury Car Pune offers exclusive travel with highly trained drivers and elite vehicles. Our service is tailored for executives, VIPs, and individuals seeking elegance and professionalism. Enjoy a smooth, private, and stylish ride across Pune with full chauffeur support."
  },
  {
    "name": "Executive Cab Pune",
    "description": "Executive Cab Pune provides top-notch transportation for business professionals. With luxury sedans, punctual chauffeurs, and a focus on comfort, this service is perfect for corporate travel, meetings, and client pickups. We ensure discretion, efficiency, and an impeccable ride every time."
  },
  {
    "name": "Luxury Sedan Hire Pune",
    "description": "Luxury Sedan Hire Pune features sleek, well-maintained vehicles perfect for solo travelers or couples who appreciate premium travel. Our sedans include plush interiors, air conditioning, and expert drivers who ensure a safe, timely, and refined ride throughout the city."
  },
  {
    "name": "Luxury SUV Rental Pune",
    "description": "Luxury SUV Rental Pune offers spacious and upscale transportation for families, business groups, or travelers with extra luggage. With high-end interiors, advanced safety features, and professional chauffeurs, our SUVs provide a perfect blend of power and comfort."
  },
  {
    "name": "Corporate Luxury Cab Pune",
    "description": "Corporate Luxury Cab Pune is designed for business needs, offering premium vehicles, trained chauffeurs, and reliable service. We support contract bookings, employee transportation, and executive transfers with an emphasis on timeliness, privacy, and professionalism."
  },
  {
    "name": "Wedding Luxury Cab Pune",
    "description": "Wedding Luxury Cab Pune adds elegance to your special day with beautifully maintained luxury cars and courteous chauffeurs. Ideal for bride and groom entries or guest transfers, our service ensures a grand and comfortable experience on your wedding day."
  },
  {
    "name": "Affordable Luxury Cab Pune",
    "description": "Affordable Luxury Cab Pune makes premium travel accessible with competitive rates and no compromise on quality. Experience high-end vehicles, professional drivers, and reliable service tailored for budget-conscious customers seeking a touch of luxury."
  },
  {
    "name": "Best Luxury Cab Pune",
    "description": "Recognized as the Best Luxury Cab Pune service, we provide excellence in comfort, punctuality, and customer satisfaction. Our fleet includes luxury sedans and SUVs, driven by expert chauffeurs available 24x7 for any occasion requiring a superior travel experience."
  },
  {
    "name": "Online Luxury Cab Booking Pune",
    "description": "Online Luxury Cab Booking Pune allows quick and hassle-free reservations for your premium transportation needs. With instant confirmation, fare transparency, and real-time tracking, our digital platform ensures a smooth and efficient luxury cab booking experience."
  },
  {
    "name": "Luxury Cab Packages Pune",
    "description": "Luxury Cab Packages Pune offers curated travel plans for weddings, sightseeing, corporate events, and more. Enjoy flexible hourly or daily rental options with luxury vehicles and professional chauffeurs, providing premium service tailored to your itinerary."
  },
  {
    "name": "Luxury Airport Cab Pune",
    "description": "Luxury Airport Cab Pune ensures timely and elegant transfers to and from Pune airport. Our service includes flight monitoring, luggage assistance, and premium vehicles, providing a first-class experience for business and leisure travelers alike."
  },
  {
    "name": "Luxury Car Rentals Pune",
    "description": "Luxury Car Rentals Pune offers a wide range of high-end vehicles for self-drive or chauffeur-driven experiences. Whether for business, leisure, or special occasions, our rentals provide the perfect blend of style, comfort, and convenience across the city."
  }
],
"tableData": [
  ["Luxury Cab Bookings in Pune", "Book Luxury Taxi Pune"],
  ["Premium Cab Booking Pune", "Chauffeur Driven Luxury Car Pune"],
  ["Executive Cab Pune", "Luxury Sedan Hire Pune"],
  ["Luxury SUV Rental Pune", "Corporate Luxury Cab Pune"],
  ["Wedding Luxury Cab Pune", "Affordable Luxury Cab Pune"],
  ["Best Luxury Cab Pune", "Online Luxury Cab Booking Pune"],
  ["Luxury Cab Packages Pune", "Luxury Airport Cab Pune"],
  ["Luxury Car Rentals Pune", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Luxury Cab Bookings in Pune",
    "WhyChoosedescription": "Aaryan Travels offers premium luxury cab services in Pune for a comfortable and stylish travel experience."
  },
  {
    "WhyChooseheading": "Punctual and Professional Service",
    "WhyChoosedescription": "Our chauffeurs ensure timely pickups and drop-offs, making your luxury travel smooth and stress-free."
  },
  {
    "WhyChooseheading": "Well-Maintained Luxury Vehicles",
    "WhyChoosedescription": "Travel in top-notch, sanitized luxury cars that are regularly serviced for your safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Pune Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with Pune's roads, ensuring efficient and hassle-free rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Enjoy upfront pricing that covers all costs, including tolls and driver allowances, for a worry-free booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Bookings",
    "WhyChoosedescription": "Our customer care team is available around the clock to assist you with luxury cab bookings and inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking for One-Way or Round Trips",
    "WhyChoosedescription": "Choose luxury cab rides tailored to your schedule, whether for a quick ride or an extended trip."
  },
  {
    "WhyChooseheading": "Variety of Luxury Vehicle Options",
    "WhyChoosedescription": "Select from premium sedans, SUVs, or other luxury cars to match your preference and travel needs."
  }
]


































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury cab bookings in Pune?',
    answer: 'Yes, Aaryan Travels provides premium luxury cab services in Pune, offering a comfortable and stylish travel experience.',
  },
  {
    question: 'How can I book luxury cabs in Pune with Aaryan Travels?',
    answer: 'You can book luxury cabs easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of luxury vehicles are available for bookings in Pune?',
    answer: 'Aaryan Travels offers a range of luxury vehicles including sedans, SUVs, and premium cars tailored to your preferences.',
  },
  {
    question: 'Are the drivers experienced in Pune city routes for luxury cab services?',
    answer: 'Absolutely. Our professional drivers are licensed and familiar with Pune routes to ensure a smooth and safe journey.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for luxury cab bookings in Pune?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere within Pune and nearby areas.',
  },
  {
    question: 'Is luxury cab service available 24x7 in Pune?',
    answer: 'Yes, Aaryan Travels offers round-the-clock luxury cab services in Pune to fit your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for luxury cab services?',
    answer: 'All luxury vehicles are sanitized regularly, and drivers follow strict safety protocols for your protection.',
  },
  {
    question: 'What payment options are accepted for luxury cab bookings in Pune?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Is there customer support available during luxury cab rides in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'The luxury cab from Aaryan Travels made my Pune trip truly special with its comfort and style. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Deshmukh',
    feedback: 'Smooth, luxurious, and professional service by Aaryan Travels in Pune. Will definitely book again!',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const luxuryCabBookingsPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Cab Bookings in Pune",
  "description": "Aaryan Travels offers premium luxury cab bookings in Pune with chauffeur-driven luxury sedans and SUVs, ideal for corporate, weddings, airport transfers, and more.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Luxury Cab Booking",
  "keywords": "Luxury Cab Bookings in Pune, Book Luxury Taxi Pune, Premium Cab Booking Pune, Chauffeur Driven Luxury Car Pune, Executive Cab Pune, Luxury Sedan Hire Pune, Luxury SUV Rental Pune, Corporate Luxury Cab Pune, Wedding Luxury Cab Pune, Affordable Luxury Cab Pune, Best Luxury Cab Pune, Online Luxury Cab Booking Pune, Luxury Cab Packages Pune, Luxury Airport Cab Pune, Luxury Car Rentals Pune"
};






  return (
    <div>

<Helmet>
  <title>Luxury Cab Bookings in Pune | Premium Luxury Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Book luxury cab services in Pune with Aaryan Travels. Choose from chauffeur-driven luxury sedans and SUVs for corporate, wedding, airport transfers, and special occasions."
  />
  <meta
    name="keywords"
    content="Luxury Cab Bookings in Pune, Book Luxury Taxi Pune, Premium Cab Booking Pune, Chauffeur Driven Luxury Car Pune, Executive Cab Pune, Luxury Sedan Hire Pune, Luxury SUV Rental Pune, Corporate Luxury Cab Pune, Wedding Luxury Cab Pune, Affordable Luxury Cab Pune, Best Luxury Cab Pune, Online Luxury Cab Booking Pune, Luxury Cab Packages Pune, Luxury Airport Cab Pune, Luxury Car Rentals Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryCabBookingsPuneSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycabbookinginpune;